<template>
  <v-dialog
    v-model="show"
    max-width="580"
    color="background"
    overlay-color="darktext"
    overlay-opacity="0.6"
  >
    <v-card data-testid="forgoten-password-card">
      <v-card-title class="pb-0 pt-6 px-6 text-h5">
        {{ cdTitle }}
      </v-card-title>
      <v-card-text class="pt-4 pb-0 px-6">
        {{ cdText }}
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="sendEmail()"
          @submit.prevent
        >
          <v-text-field
            ref="email"
            v-model="emailFogottenPass"
            data-testid="email-input"
            solo
            elevation="6"
            class="rounded-xxl text-body-2 pt-4"
            :placeholder="$t('loginEmailPlaceholder')"
            :rules="emailRules"
          />
          <v-card-actions class="pt-4 pt-0 pb-6 px-6">
            <v-spacer />
            <v-btn
              color="darktext"
              class="rounded-xxl text-none  py-3 white--text"
              @click="show=false"
            >
              {{ cdCancelBtn }}
            </v-btn>
            <v-btn
              data-testid="send-mail-button"
              type="submit"
              color="accent"
              class="rounded-xxl text-none  py-3"
              @click="sendEmail()"
            >
              {{ cdSubmitBtn }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { ruleRequired } from '../rules/formRules.js';
import { checkEmail } from '../api/userApi';
import i18n from '../plugins/i18n';

export default {
  props: {
    visible: Boolean,
    //id: Number,
    cdTitle: {
      type: String,
      default: ''
    },
    cdText: {
      type: String,
      default: ''
    },
    cdSubmitBtn: {
      type: String,
      default: i18n.t('submit')
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t('cancel')
    },
  },
  data(){
    return{
      valid: true,
      emailFogottenPass: '',
      emailRules: ruleRequired('labelEmail'),
      language: window.$cookies.get('language') ? window.$cookies.get('language') : 'sv',
      alertType:'',
      alertMsg:'',
    }
  },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  methods: {
    async sendEmail() {
      this.$refs.form.validate()
      if(this.valid){
              
                var alertType = ''
                var alertMsg = ''
                try {
                    this.language = window.$cookies.get('language') ? window.$cookies.get('language') : 'sv'
                    let data = {
                      email: this.emailFogottenPass,
                      language: this.language
                    };
                    const response = await checkEmail(data)
                    if(response.status == 200) {
                        alertType = 'success'
                        alertMsg =  i18n.t('instructionsFoggotenPassSent')
                        this.$emit('proceedSend', alertMsg, alertType)
                        
                    }
                    
                    this.$refs.form.reset()
                } catch (e) {
                    if(e.response){
                       alertType = 'error'
                        if(e.response.status == 404){
                          alertMsg =  i18n.t('errorInstructionsFoggotenPassSent')
                           this.$emit('proceedSend', alertMsg, alertType)
                        }
                        else if(e.response.status == 422) {
                            alertMsg =  i18n.t('notValidEmailAddress')
                             this.$emit('proceedSend', alertMsg, alertType)
                        }else if(e.response.status == 403){
                            for (let i = 0; i < e.response.data.errors.length; i++) {
                                if (e.response.data.errors[i].detail == 'You must log in using SSO') {
                                    alertMsg =  i18n.t('mustLogInUsingSSO')
                                    this.$emit('proceedSend', alertMsg, alertType)
                                }else{
                                    alertMsg =  i18n.t('serverError')
                                    this.$emit('proceedSend', alertMsg, alertType)
                                }
                            }
                        }else{
                            alertMsg =  i18n.t('serverError')
                            this.$emit('proceedSend', alertMsg, alertType)
                        }
                    }
                }
                 this.$refs.form.reset()
            }
        },
  },
}
</script>